module.exports = __webpack_public_path__ + "./assets/google-play-badge.png";